<template>
  <div id="wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="财务数据导入" name="first">
        <div class="flex flex-start flex-wrap">
          <el-form
            :inline="true"
            class="from"
            ref="formQuery"
            :model="queryParams"
          >
            <el-form-item label="凭证号：">
              <el-input
                placeholder="请输入"
                v-model="queryParams.voucherNumber"
              ></el-input>
            </el-form-item>
            <el-form-item label="日期：">
              <el-date-picker
                v-model="queryParams.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="timeChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item class="item_btn">
              <el-button type="primary" @click="handleQuerys"
                ><i class="el-icon-search"></i> 查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <div class="flex flex-start" style="margin-top: 15px">
          <el-button type="primary" @click="upload.open = true"
            >批量导入</el-button
          >
        </div>

        <!--        <div class="flex flex-justify title_box">-->
        <!--          <div>-->
        <!--            <i class="el-icon-warning" style="color: #4988df">-->
        <!--              已选择 <span>0</span> 项-->
        <!--            </i>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <el-link type="primary" style="margin-left: 20px" :underline="false"-->
        <!--            >删除</el-link-->
        <!--            >-->
        <!--          </div>-->
        <!--        </div>-->

        <!-- 导入 -->
        <el-dialog
          title="批量导入"
          :visible.sync="upload.open"
          center
          width="44%"
        >
          <div class="dialog_content">
            <div class="download" style="margin-top: 20px; line-height: 25px">
              <div>填写需要导入的数据</div>
              <div style="color: #a3adb9">
                请按照数据模板的格式准备导入数据,模板中的表头名称不可更改,表头行不能删除,表格格式不能修改
              </div>
              <div>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="importTemplate"
                  >下载模板</el-link
                >
              </div>
            </div>
            <div class="upload" style="margin-top: 20px; line-height: 25px">
              <div>上传填好的表格</div>
              <div style="color: #a3adb9">
                文件后缀名必须为xls或xsx (即Excel格式) ,文件大小不得大于5M
              </div>
              <el-upload
                class="upload-demo"
                ref="upload"
                :limit="1"
                accept=".xlsx, .xls"
                :action="upload.url"
                :disabled="upload.isUploading"
                :auto-upload="false"
                :data="{ whetherHighTech: 2, projectId: projectId }"
                :on-progress="handleFileProgress"
                :on-success="handleFileSuccess"
                :on-exceed="handleFileExceed"
              >
                <el-link type="primary" :underline="false">上传文件</el-link>
              </el-upload>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="upload.open = false">取 消</el-button>
            <el-button type="primary" @click="submitFileForm">保存</el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="凭证列表"
          :visible.sync="centerDialogVisible"
          width="30%"
          center
        >
          <div>
            <el-form
              label-width="120px"
              :model="formData"
              :rules="rules"
              ref="formData"
            >
              <el-form-item v-if="!type" prop="projectId" label="选择项目：">
                <el-select v-model="formData.projectId" placeholder="项目">
                  <el-option
                    v-for="dict in projectList"
                    :key="dict.id"
                    :label="dict.projectName"
                    :value="dict.id"
                    placeholder="请选择"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="documentDate" label="凭证日期：">
                <el-date-picker
                  :editable="false"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  v-model="formData.documentDate"
                  placeholder="请选择"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="voucherFont" label="凭证字：">
                <el-radio
                  v-for="dict in voucherFont"
                  v-model="formData.voucherFont"
                  :key="dict.dictCode"
                  :label="dict.dictCode"
                  >{{ dict.dictName }}</el-radio
                >
              </el-form-item>
              <el-form-item prop="voucherNumber" label="凭证号：">
                <el-input v-model="formData.voucherNumber"></el-input>
              </el-form-item>
              <el-form-item prop="summary" label="摘要：">
                <el-input v-model="formData.summary"></el-input>
              </el-form-item>
              <el-form-item prop="subjectId" label="科目代码/名称：">
                <el-select
                  v-model="formData.subjectId"
                  placeholder="请选择科目代码/名称"
                >
                  <el-option-group
                    v-for="(group, i) in subjectList"
                    :key="i"
                    :label="i"
                  >
                    <el-option
                      v-for="item in group"
                      :key="item.id"
                      :label="item.subjectName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
              <el-form-item prop="voucherAmount" label="凭证金额：">
                <el-input-number
                  :controls="false"
                  v-model="formData.voucherAmount"
                ></el-input-number>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">返回</el-button>
            <el-button type="primary" @click="classSubmitForm">保存</el-button>
          </span>
        </el-dialog>

        <el-table
          class="table"
          :data="tableData"
          :header-cell-style="{ background: '#F5F7FA' }"
          stripe
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            label="凭证日期"
            prop="documentDate"
          ></el-table-column>
          <el-table-column prop="voucherNumber" label="凭证号">
          </el-table-column>
          <el-table-column
            prop="costTypeFirst"
            label="科目"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="科目二"
            width="201"
            prop="costTypeSecond"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="科目三"
            width="201"
            prop="costTypeThird"
          ></el-table-column>
          <el-table-column label="费用" prop="voucherAmount"></el-table-column>

          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="green"
                @click="handleUpdate(scope.row.id)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                class="red"
                @click="handleDelete(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="flex flex-end">
          <el-pagination
            class="pagination"
            background
            v-show="total > 0"
            :total="total"
            :current-page.sync="queryParams.pageNum"
            :page-size.sync="queryParams.pageSize"
            @current-change="getLists"
          >
          </el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="财务数据管理" name="second" :lazy="true">
        <fixed-assets :projectId="projectId" :type="type" ref="fixedAssets" />
      </el-tab-pane>
    </el-tabs>
    <import-tips
      :show="importOpen"
      :data="importData"
      :succeedNumber="importSucceedNumber"
      :errorNumber="importErrorNumber"
      @importOpnes="importOpnes"
    />
  </div>
</template>

<script>
import importTips from "./finances/importTips.vue";
import fixedAssets from "../fixedAssets";
import {
  voucherQuerySubjects,
  vouchertQuery,
  voucherQueryOne,
  voucherUpdate,
  voucherDelete,
  importDateDownloadTemplate,
} from "./fixedAssets";
import { getDict } from "@/api/ChinaHigh";
export default {
  components: {
    fixedAssets,
    importTips,
  },
  data() {
    return {
      upload: {
        // 是否显示弹出层
        open: false,
        // 是否禁用上传
        isUploading: false,
        // 上传的地址
        url: this.mainBaseURL + "/voucher/importVouchers",
      },
      importOpen: false,
      importData: [],
      importSucceedNumber: 0,
      importErrorNumber: 0,
      centerDialogVisible: false,
      tableData: [],
      activeName: "first",
      projectId: "123",
      type: true,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      formData: {},
      //日期限制
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      voucherFont: [],
      subjectList: [],
      rules: {
        documentDate: [
          { required: true, message: "请选择凭证日期", trigger: "change" },
        ],
        voucherFont: [
          { required: true, message: "请选择凭证字", trigger: "change" },
        ],
        voucherNumber: [
          { required: true, message: "请输入凭证号", trigger: "blur" },
        ],
        summary: [{ required: true, message: "请输入摘要", trigger: "blur" }],
        subjectId: [
          { required: true, message: "请选择科目代码/名称", trigger: "change" },
        ],
        voucherAmount: [
          { required: true, message: "请输入凭证金额", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.projectId = sessionStorage.getItem("zt_jjkc_project_id");
    this.resetQuerys();
    this.chushi();
  },
  methods: {
    chushi() {
      getDict({ type: "loan_type" }).then((res) => {
        this.voucherFont = res.data;
      });
      voucherQuerySubjects().then((res) => {
        this.subjectList = res.data;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "background:#fff";
      } else {
        return "background:#F5F7FA";
      }
    },
    getLists() {
      vouchertQuery(this.queryParams).then((res) => {
        if (res.code == "00000") {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    /** 搜索按钮操作 */
    handleQuerys() {
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.getLists();
    },
    /** 重置按钮操作 */
    resetQuerys() {
      this.resetForm("formQuery");
      this.queryParams = {};
      this.queryParams.projectId = this.projectId;
      this.queryParams.whetherHighTech = 2;
      this.queryParams.importFlag = 1;
      this.queryParams.beginTime = "";
      this.queryParams.endTime = "";
      this.handleQuerys();
    },
    // 表单重置
    reseForm() {
      this.formData = {};
      this.formData.projectId = this.projectId;
      this.resetForm("formData");
    },
    handleUpdate(id) {
      this.reseForm();
      voucherQueryOne(id).then((res) => {
        this.formData = res.data;
        this.centerDialogVisible = true;
      });
    },
    classSubmitForm() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          if (this.formData.id == undefined || this.formData.id == "") {
            voucherAdd(this.formData).then((res) => {
              if (res.code === "00000") {
                this.handleQuerys();
                this.centerDialogVisible = false;
                this.msgSuccess(res.msg);
              }
            });
          } else {
            voucherUpdate(this.formData).then((res) => {
              if (res.code === "00000") {
                this.handleQuerys();
                this.centerDialogVisible = false;
                this.msgSuccess(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    handleDelete(id) {
      this.$confirm("是否确认删除凭证?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return voucherDelete({ ids: [id] });
        })
        .then(() => {
          this.getLists();
          this.msgSuccess("删除成功");
        })
        .catch(function () {});
    },
    // 日期选择
    timeChange(val) {
      if (val != null) {
        this.queryParams.beginTime = val[0];
        this.queryParams.endTime = val[1];
      } else {
        this.queryParams.beginTime = "";
        this.queryParams.endTime = "";
      }
    },
    importTemplate() {
      importDateDownloadTemplate(7).then((res) => {
        if ((res.code = "00000")) {
          window.open(res.data);
        }
      });
    },
    handleFileProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    handleFileSuccess(response, file, fileList) {
      if (response.code == "00000") {
        this.upload.open = false;
        this.upload.isUploading = false;
        this.$refs.upload.clearFiles();
        this.importOpen = true;
        this.importData = response.data.errorList;
        this.importSucceedNumber = response.data.succeedNumber;
        this.importErrorNumber = response.data.errorNumber;
        this.getLists();
      } else {
        this.upload.isUploading = false;
        this.$refs.upload.abort();
        this.$message.error(response.msg);
      }
    },
    submitFileForm() {
      this.$refs.upload.submit();
    },
    handleFileExceed(response) {
      this.$alert("只能上传一个文件");
    },
    importOpnes() {
      this.importOpen = false;
      this.importData = [];
      this.importSucceedNumber = 0;
      this.importErrorNumber = 0;
    },
    handleClick(tab, event) {
      if (tab.name == "first") {
        this.resetQuerys();
      }

      if (tab.name == "second") {
        this.$refs["fixedAssets"].qh();
      }
    },
  },
};
</script>
<style scoped>
.title_box {
  width: 100%;
  height: 40px;
  background-color: #e6f7ff;
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 20px 0;
}
.form_box .el-form-item {
  width: 46%;
}
.text {
  font-size: 14px;
  padding: 10px 20px;
  position: relative;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 20px;
}
.text::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 10px;
  background: #7c99fd;
}
.gsadd {
  position: absolute;
  left: 17px;
  top: 20px;
  z-index: 9;
}
.item_btn {
  float: right;
}
</style>
